import type { ProductTileData } from '../component/product-tile/ProductTile';

const getProductTileProps = ({ Product, Professional }: ProductTileData) => {
    return {
        productName: Product.Title,
        productLink: Product.Link,
        imageUrl:
            Product.LibraryThumb?.LibraryImage?.LibraryImageFile
                ?.ThumbnailDirectoryTile ??
            Product.LibraryThumb?.ThumbImageFile?.DirectoryPageSquare.Desktop ??
            '',
        professional: Professional.Title,
        professionalLink: Professional.Link,
        variantColors: Product.Colors,
        variantColorCount: Product.ColorsCount,
        mixBlendMode: Product.LibraryThumb?.LibraryImage?.IsMultiplied
            ? 'multiply'
            : 'normal',
    };
};

export default getProductTileProps;
